import { getCurrentHash } from '../../../../shared/router/utils/getCurrentHash';
import { parseFlightDetailsHash } from './flightDetailsUrl';

export const isDeparture = () => {
	const hash = getCurrentHash();

	const params = parseFlightDetailsHash(hash);

	return params && !params.arrival;
};
